<template>
    <div class="lease-info">
        <div class="lease-info__header">
            <h4 class="lease-info__title">Lease Information</h4>
        </div>

        <themed-form
            :fields="formFields"
            :model-value="formData"
            :errors="errors"
            layout="grid"
            :columns="4"
            @input="updateFormData"
        >
            <template #after-fields>
                <themed-button
                    variant="destructive"
                    size="default"
                    @click="confirmDeleteLease"
                    class="lease-info__delete-button"
                >
                    Delete Lease
                </themed-button>
            </template>
        </themed-form>
    </div>
</template>

<script>
import { mapState } from 'vuex';
import ThemedForm from '../form/ThemedForm.vue';
import ThemedButton from '../ThemedButton.vue';

export default {
    name: 'LeaseInfoV1',

    components: {
        ThemedForm,
        ThemedButton
    },

    props: {
        formErrors: {
            type: [String, Object],
            default: () => ({})
        }
    },

    data() {
        return {
            formData: {}
        };
    },

    computed: {
        ...mapState(['leases', 'sites']),

        errors() {
            return this.formErrors || {};
        },

        formFields() {
            return [
                {
                    name: 'name',
                    type: 'input',
                    label: 'Name',
                    placeholder: 'Lease name',
                    required: true,
                    col: 1
                },
                {
                    name: 'start_date',
                    type: 'input',
                    inputType: 'date',
                    label: 'Start Date',
                    placeholder: 'dd / mm / yyyy',
                    required: true,
                    col: 1
                },
                {
                    name: 'end_date',
                    type: 'input',
                    inputType: 'date',
                    label: 'End Date',
                    placeholder: 'dd / mm / yyyy',
                    required: true,
                    col: 1
                },
                {
                    name: 'free_months',
                    type: 'input',
                    inputType: 'number',
                    label: '# Free Months',
                    placeholder: '0',
                    col: 1
                },
                {
                    name: 'notes',
                    type: 'textarea',
                    label: 'Lease Notes',
                    placeholder: 'Lease Notes',
                    rows: 5,
                    col: 3
                },
                {
                    name: 'free_months_included',
                    type: 'toggle',
                    label: 'Free Months Included',
                    col: 1
                },
                {
                    name: 'will_not_renew',
                    type: 'toggle',
                    label: 'Will Not Renew',
                    col: 1
                }
            ];
        }
    },

    watch: {
        'leases.selectedLease': {
            immediate: true,
            deep: true,
            handler(lease) {
                if (lease) {
                    this.formData = {
                        name: lease.name || '',
                        start_date: lease.start_date || '',
                        end_date: lease.end_date || '',
                        notes: lease.notes || '',
                        free_months: lease.free_months || '',
                        free_months_included: lease.free_months_included || false,
                        will_not_renew: lease.will_not_renew || false
                    };
                }
            }
        },

        formData: {
            deep: true,
            handler(newData) {
                if (this.leases.selectedLease) {
                    Object.assign(this.leases.selectedLease, newData);
                }
            }
        }
    },

    methods: {
        updateFormData(data) {
            this.formData = data;
        },

        confirmDeleteLease() {
            const leaseId = this.leases.selectedLease?.id;

            if (leaseId === 'new') {
                this.removeLease();
                return;
            }

            this.$swal({
                title: 'Are you sure?',
                text: "Are you sure you want to delete this Lease?",
                type: 'warning',
                buttonsStyling: false,
                confirmButtonText: 'Yes - Delete it',
                confirmButtonClass: 'btn btn-red',
                showCancelButton: true,
                cancelButtonClass: 'btn btn-secondary mr-4',
                reverseButtons: true
            }).then((result) => {
                if (result.value) {
                    this.deleteLease();
                }
            });
        },

        deleteLease() {
            const leaseId = this.leases.selectedLease?.id;

            axios.delete('/leases/' + leaseId)
                .then((response) => {
                    this.$notify({
                        type: 'success',
                        title: 'Success',
                        text: response.data.message
                    });

                    this.removeLease();
                })
                .catch((error) => {
                    this.$notify({
                        type: 'error',
                        title: 'Error',
                        text: error.response?.data?.message || 'Failed to delete lease'
                    });
                });
        },

        removeLease() {
            const leaseId = this.leases.selectedLease?.id;

            _.remove(this.sites.selectedSite.leases, (lease) => {
                return lease.id == leaseId;
            });

            this.leases.selectedLease = this.sites.selectedSite.leases[0] || null;
            this.$eventHub.$emit('change-section', 'lease-info');
        }
    }
};
</script>
